import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {

    getIndicacao() {
      return axios.get('/indicacao')
    },

    getEstatistica() {
      return axios.get('/indicacao/rede')
    },

    // Buscar bônus da empresa (dados gerais)
    getBonusEmpresa() {
      return new Promise((resolve, reject) => {
        axios
          .get('/bonus')
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    // Buscar bônus do usuário (status individual)
    getBonus() {
      return new Promise((resolve, reject) => {
        axios
          .get('/usuario-bonus/meus-bonus')
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    getBonusAtivos() {
      return new Promise((resolve, reject) => {
        axios
          .get('/usuario-bonus/bonus-ativos')
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    getBonusComissao() {
      return new Promise((resolve, reject) => {
        axios
          .get('/usuario-bonus/bonus-comissao')
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    reclassificarBonus() {
      return new Promise((resolve, reject) => {
        axios
          .post('/usuario-bonus/reclassificar')
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

  },
}
